import { FC } from 'react'
import { useTheme } from 'next-themes'

import LoadingAnimation from '@/components/shared/LoadingAnimation'
import { BRANDED_MODE_COLORS } from '@/utils/brandingThemeUtil'

/**
 * Covers the app while its branding loads, in the neutral colours every branded console
 * sits on, so neither Grid's theme nor a half-applied brand shows first.
 */
export const BrandingSplash: FC = () => {
  const { resolvedTheme } = useTheme()
  const mode = resolvedTheme === 'dark' ? 'dark' : 'light'

  // Hidden from assistive tech: the page underneath is already rendered and readable, and
  // the cover only spares sighted users the restyle.
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ backgroundColor: BRANDED_MODE_COLORS[mode].page }}
      aria-hidden="true"
      data-testid="branding-splash"
    >
      <LoadingAnimation neutral color={mode === 'dark' ? 'primaryDark' : 'primaryLight'} className="h-[72px] w-[72px]" />
    </div>
  )
}
